import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import Toolbar from '@mui/material/Toolbar';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import ListIcon from '@mui/icons-material/List';
import FormatListNumbered from '@mui/icons-material/FormatListNumbered';
import LinkIcon from '@mui/icons-material/Link';
import { Box, IconButton, Popover, TextField } from '@mui/material';
import SecondaryContainedButton from '@/components/buttons/SecondaryContainedButton';
const EditorToolbar = t0 => {
  const $ = _c(58);
  const {
    editor
  } = t0;
  const [urlPopoverAnchorEl, setUrlPopoverAnchorEl] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [urlPopoverAnchorPosition, setUrlPopoverAnchorPosition] = useState(t1);
  const [anchorReference, setAnchorReference] = useState("none");
  const [textToDisplay, setTextToDisplay] = useState("");
  const [urlToLink, setUrlToLink] = useState("");
  const [savedSelection, setSavedSelection] = useState(null);
  const [, setTick] = useState(0);
  const isPopOverOpen = Boolean(urlPopoverAnchorEl) || Boolean(urlPopoverAnchorPosition.top && urlPopoverAnchorPosition.left);
  let t2;
  if ($[1] !== editor || $[2] !== setTick) {
    t2 = () => {
      if (!editor) {
        return;
      }
      const update = () => setTick(_temp);
      editor.on("transaction", update);
      editor.on("selectionUpdate", update);
      return () => {
        editor.off("transaction", update);
        editor.off("selectionUpdate", update);
      };
    };
    $[1] = editor;
    $[2] = setTick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== editor) {
    t3 = [editor];
    $[4] = editor;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== urlPopoverAnchorEl || $[7] !== urlPopoverAnchorPosition.left || $[8] !== urlPopoverAnchorPosition.top) {
    t4 = () => {
      if (urlPopoverAnchorPosition.top && urlPopoverAnchorPosition.left) {
        setAnchorReference("anchorPosition");
      } else {
        if (urlPopoverAnchorEl) {
          setAnchorReference("anchorEl");
        }
      }
    };
    $[6] = urlPopoverAnchorEl;
    $[7] = urlPopoverAnchorPosition.left;
    $[8] = urlPopoverAnchorPosition.top;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== urlPopoverAnchorEl || $[11] !== urlPopoverAnchorPosition) {
    t5 = [urlPopoverAnchorPosition, urlPopoverAnchorEl];
    $[10] = urlPopoverAnchorEl;
    $[11] = urlPopoverAnchorPosition;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useEffect(t4, t5);
  if (!editor) {
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Toolbar variant="dense"><Box sx={{
          height: 48
        }} /></Toolbar>;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    return t6;
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <UndoIcon />;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let T0;
  let handleCreateLink;
  let handleUrlPopoverClose;
  let t7;
  let t8;
  let t9;
  if ($[15] !== editor || $[16] !== savedSelection || $[17] !== textToDisplay || $[18] !== urlToLink) {
    const tools = [{
      label: "Undo",
      method: "undo",
      icon: t6
    }, {
      label: "Redo",
      method: "redo",
      icon: <RedoIcon />
    }, {
      label: "bold",
      method: "bold",
      icon: <FormatBoldIcon />
    }, {
      label: "italic",
      method: "italic",
      icon: <FormatItalicIcon />
    }, {
      label: "underline",
      method: "underline",
      icon: <FormatUnderlinedIcon />
    }, {
      label: "Unordered-List",
      method: "bulletList",
      icon: <ListIcon />
    }, {
      label: "Ordered-List",
      method: "orderedList",
      icon: <FormatListNumbered />
    }, {
      label: "link",
      method: "link",
      icon: <LinkIcon sx={{
        transform: "rotate(135deg)"
      }} />
    }];
    const isActive = t10 => {
      const {
        method
      } = t10;
      switch (method) {
        case "undo":
          {
            return editor.can().chain().focus().undo().run();
          }
        case "redo":
          {
            return editor.can().chain().focus().redo().run();
          }
        case "bold":
          {
            return editor.isActive("bold");
          }
        case "italic":
          {
            return editor.isActive("italic");
          }
        case "underline":
          {
            return editor.isActive("underline");
          }
        case "bulletList":
          {
            return editor.isActive("bulletList");
          }
        case "orderedList":
          {
            return editor.isActive("orderedList");
          }
        case "link":
          {
            return editor.isActive("link");
          }
        default:
          {
            return false;
          }
      }
    };
    let t11;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = e => {
        e?.preventDefault?.();
        setUrlPopoverAnchorEl(null);
        setUrlPopoverAnchorPosition({});
        setAnchorReference("none");
        setTextToDisplay("");
        setUrlToLink("");
        setSavedSelection(null);
      };
      $[25] = t11;
    } else {
      t11 = $[25];
    }
    handleUrlPopoverClose = t11;
    const handleUrlIconClicked = event => {
      event.preventDefault();
      const {
        from,
        to,
        empty
      } = editor.state.selection;
      const existingHref = editor.getAttributes("link").href || "";
      setUrlToLink(existingHref);
      if (empty && !editor.isActive("link")) {
        setSavedSelection({
          from,
          to
        });
        setTextToDisplay("");
        setUrlPopoverAnchorEl(event.currentTarget);
        return;
      }
      let selFrom = from;
      let selTo = to;
      if (editor.isActive("link")) {
        editor.commands.extendMarkRange("link");
        selFrom = editor.state.selection.from;
        selTo = editor.state.selection.to;
      }
      setSavedSelection({
        from: selFrom,
        to: selTo
      });
      const selectedText = editor.state.doc.textBetween(selFrom, selTo, " ");
      setTextToDisplay(selectedText);
      const nativeSelection = window.getSelection();
      if (nativeSelection && nativeSelection.rangeCount > 0) {
        const range = nativeSelection.getRangeAt(0);
        const rect = range.getBoundingClientRect();
        if (rect.bottom || rect.left) {
          setUrlPopoverAnchorPosition({
            top: rect.bottom,
            left: rect.left
          });
          return;
        }
      }
      setUrlPopoverAnchorEl(event.currentTarget);
    };
    const handleClick = (e_0, item) => {
      e_0.preventDefault();
      const chain = editor.chain().focus();
      bb88: switch (item.method) {
        case "undo":
          {
            chain.undo().run();
            break bb88;
          }
        case "redo":
          {
            chain.redo().run();
            break bb88;
          }
        case "bold":
          {
            chain.toggleBold().run();
            break bb88;
          }
        case "italic":
          {
            chain.toggleItalic().run();
            break bb88;
          }
        case "underline":
          {
            chain.toggleUnderline().run();
            break bb88;
          }
        case "bulletList":
          {
            chain.toggleBulletList().run();
            break bb88;
          }
        case "orderedList":
          {
            chain.toggleOrderedList().run();
            break bb88;
          }
        case "link":
          {
            handleUrlIconClicked(e_0);
            break bb88;
          }
        default:
      }
    };
    handleCreateLink = () => {
      if (!urlToLink) {
        handleUrlPopoverClose();
        return;
      }
      const sel = savedSelection;
      const chain_0 = editor.chain().focus();
      if (sel && sel.from !== sel.to) {
        chain_0.setTextSelection(sel).insertContent(textToDisplay || urlToLink).setTextSelection({
          from: sel.from,
          to: sel.from + (textToDisplay || urlToLink).length
        }).setLink({
          href: urlToLink
        }).run();
      } else {
        if (sel) {
          const text = textToDisplay || urlToLink;
          chain_0.setTextSelection(sel.from).insertContent(text).setTextSelection({
            from: sel.from,
            to: sel.from + text.length
          }).setLink({
            href: urlToLink
          }).run();
        }
      }
      handleUrlPopoverClose();
    };
    t9 = _temp2;
    T0 = Toolbar;
    t7 = "dense";
    t8 = tools.map((item_0, idx) => <IconButton style={{
      color: isActive(item_0) ? "rgba(0, 0, 0, 1)" : "rgba(0, 0, 0, 0.3)"
    }} key={`${item_0.label}-${idx}`} title={item_0.label} onClick={e_2 => handleClick(e_2, item_0)} onMouseDown={_temp3}>{item_0.icon || item_0.label}</IconButton>);
    $[15] = editor;
    $[16] = savedSelection;
    $[17] = textToDisplay;
    $[18] = urlToLink;
    $[19] = T0;
    $[20] = handleCreateLink;
    $[21] = handleUrlPopoverClose;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    T0 = $[19];
    handleCreateLink = $[20];
    handleUrlPopoverClose = $[21];
    t7 = $[22];
    t8 = $[23];
    t9 = $[24];
  }
  let t10;
  if ($[26] !== T0 || $[27] !== t7 || $[28] !== t8) {
    t10 = <T0 variant={t7}>{t8}</T0>;
    $[26] = T0;
    $[27] = t7;
    $[28] = t8;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  let t12;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      vertical: "bottom",
      horizontal: "center"
    };
    t12 = {
      vertical: "top",
      horizontal: "center"
    };
    $[30] = t11;
    $[31] = t12;
  } else {
    t11 = $[30];
    t12 = $[31];
  }
  let t13;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      overflowY: "scroll",
      py: 2,
      px: 3,
      width: "380px",
      "&::-webkit-scrollbar": {
        display: "none"
      },
      msOverflowStyle: "none",
      scrollbarWidth: "none"
    };
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = e_4 => setTextToDisplay(e_4.target.value);
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== textToDisplay) {
    t15 = <TextField variant="standard" label="text to display" value={textToDisplay} onChange={t14} fullWidth={true} />;
    $[34] = textToDisplay;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = e_5 => setUrlToLink(e_5.target.value);
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== urlToLink) {
    t17 = <TextField variant="standard" label="enter link" value={urlToLink} onChange={t16} fullWidth={true} />;
    $[37] = urlToLink;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      mt: 2,
      display: "flex",
      justifyContent: "end"
    };
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      textTransform: "none"
    };
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== handleCreateLink) {
    t20 = <Box sx={t18}><SecondaryContainedButton sx={t19} onClick={handleCreateLink}>Create Link</SecondaryContainedButton></Box>;
    $[41] = handleCreateLink;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t15 || $[44] !== t17 || $[45] !== t20) {
    t21 = <Box sx={t13} component="form">{t15}{t17}{t20}</Box>;
    $[43] = t15;
    $[44] = t17;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== anchorReference || $[48] !== handleUrlPopoverClose || $[49] !== isPopOverOpen || $[50] !== t21 || $[51] !== urlPopoverAnchorEl || $[52] !== urlPopoverAnchorPosition) {
    t22 = <Popover open={isPopOverOpen} anchorReference={anchorReference} anchorEl={urlPopoverAnchorEl} anchorPosition={urlPopoverAnchorPosition} onClose={handleUrlPopoverClose} anchorOrigin={t11} transformOrigin={t12}>{t21}</Popover>;
    $[47] = anchorReference;
    $[48] = handleUrlPopoverClose;
    $[49] = isPopOverOpen;
    $[50] = t21;
    $[51] = urlPopoverAnchorEl;
    $[52] = urlPopoverAnchorPosition;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== t10 || $[55] !== t22 || $[56] !== t9) {
    t23 = <div onClick={t9}>{t10}{t22}</div>;
    $[54] = t10;
    $[55] = t22;
    $[56] = t9;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  return t23;
};
export default EditorToolbar;
function _temp(t) {
  return t + 1;
}
function _temp2(e_1) {
  return e_1.stopPropagation();
}
function _temp3(e_3) {
  return e_3.preventDefault();
}